export default __webpack_public_path__ + "static/media/PEUGEOT_01.a028ebd6.gif";